import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const minditPreset: any = definePreset(Lara, {
  semantic: {
    colorScheme: {
      light: {
        root: {
          surface: {
            A: '#ffffff',
            B: '#f8f9fa',
            C: '#f7f7f7',
            D: '#dee2e6',
            E: '#ffffff',
            F: '#ffffff',
            0: '#ffffff',
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: '#e0e0e0',
            400: '#bdbdbd',
            500: '#9e9e9e',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
            ground: '#eff3f8',
            section: '#ffffff',
            card: '#ffffff',
            overlay: '#ffffff',
            border: '#dfe7ef',
            hover: '#f6f9fc'
          },
          gray: {
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: '#e0e0e0',
            400: '#bdbdbd',
            500: '#9e9e9e',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121'
          },
          primary: {
            color: '#e01728',
            hoverColor: '#cd0101',
            colorText: '{surface.0}',
            inverseColor: '{surface.0}',
            50:  '{red.50}',
            100: '{red.100}',
            200: '{red.200}',
            300: '{red.300}',
            400: '{red.400}',
            500: '{red.500}',
            600: '{red.600}',
            700: '{red.700}',
            800: '{red.800}',
            900: '{red.900}',
            950: '{red.950}'
          },
          content: {
            hoverBackground: '{surface.c}'
          },
          text: {
            color: '#46494f',
            colorSecondary: '#6c757d'
          },          
          highlight: {
            background: '#f9f1f3',
            color: '#cd0101'
          },
          fontFamily: "'Lato', sans-serif",
          contentPadding: '1.25rem',
          inlineSpacing: '0.5rem',
          borderRadius: '6px',
          focusRingShadow: '0 0 0 0.2rem #fce8ea',
          maskbg: 'rgba(0, 0, 0, 0.4)',


          select: {
            overlayy: {
              position: 'relative',
              width: '100%'
            }      
          }

        }
      },
      dark: {
        root: {
          surface: {
            0: '#ffffff',
            50: '{zinc.50}',
            100: '{zinc.100}',
            200: '{zinc.200}',
            300: '{zinc.300}',
            400: '{zinc.400}',
            500: '{zinc.500}',
            600: '{zinc.600}',
            700: '{zinc.700}',
            800: '{zinc.800}',
            900: '{zinc.900}',
            950: '{zinc.950}'
          },
          primary: {
            color: '#cd0101',
            hoverColor: '#e01728',
            colorText: '{surface.300}',
            inverseColor: '{surface.900}',
            50:  '{red.50}',
            100: '{red.100}',
            200: '{red.200}',
            300: '{red.300}',
            400: '{red.400}',
            500: '{red.500}',
            600: '{red.600}',
            700: '{red.700}',
            800: '{red.800}',
            900: '{red.900}',
            950: '{red.950}'
          },
          highlight: {
            background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
            focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
            color: 'rgba(255,255,255,.87)',
            focusColor: 'rgba(255,255,255,.87)'
          },
          focusRing: {
            shadow: '0 0 0 0.2rem color-mix(in srgb, {primary.color}, transparent 80%)'
          },
          mask: {
            background: 'rgba(0,0,0,0.6)',
            color: '{surface.200}'
          },
          formField: {
            background: '{surface.950}',
            disabledBackground: '{surface.700}',
            filledBackground: '{surface.800}',
            filledHoverBackground: '{surface.800}',
            filledFocusBackground: '{surface.950}',
            borderColor: '{surface.600}',
            hoverBorderColor: '{primary.color}',
            focusBorderColor: '{primary.color}',
            invalidBorderColor: '{red.300}',
            color: '{surface.0}',
            disabledColor: '{surface.400}',
            placeholderColor: '{surface.400}',
            invalidPlaceholderColor: '{red.400}',
            floatLabelColor: '{surface.400}',
            floatLabelFocusColor: '{primary.color}',
            floatLabelActiveColor: '{surface.400}',
            floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
            iconColor: '{surface.400}',
            shadow: 'none'
          },
          text: {
            color: '{surface.50}',
            hoverColor: '{surface.0}',
            mutedColor: '{surface.400}',
            hoverMutedColor: '{surface.300}',
            colorSecondary: '#6c757d'
          },
          content: {
            background: '{surface.700}',
            hoverBackground: '{surface.800}',
            borderColor: '{surface.700}',
            color: '{text.color}',
            hoverColor: '{text.hover.color}'
          },
          overlay: {
            select: {
              background: '{surface.900}',
              borderColor: '{surface.700}',
              color: '{text.color}'
            },
            popover: {
              background: '{surface.900}',
              borderColor: '{surface.700}',
              color: '{text.color}'
            },
            modal: {
              background: '{surface.900}',
              borderColor: '{surface.700}',
              color: '{text.color}'
            }
          },
          list: {
            option: {
              focusBackground: '{surface.800}',
              selectedBackground: '{highlight.background}',
              selectedFocusBackground: '{highlight.focus.background}',
              color: '{text.color}',
              focusColor: '{text.hover.color}',
              selectedColor: '{highlight.color}',
              selectedFocusColor: '{highlight.focus.color}',
              icon: {
                color: '{surface.500}',
                focusColor: '{surface.400}'
              }
            },
            optionGroup: {
              background: 'transparent',
              color: '{text.color}'
            }
          },
          navigation: {
            item: {
              focusBackground: '{surface.800}',
              activeBackground: '{surface.800}',
              color: '{text.color}',
              focusColor: '{text.hover.color}',
              activeColor: '{text.hover.color}',
              icon: {
                color: '{surface.500}',
                focusColor: '{surface.400}',
                activeColor: '{surface.400}'
              }
            },
            submenuLabel: {
              background: 'transparent',
              color: '{text.color}'
            },
            submenuIcon: {
              color: '{surface.500}',
              focusColor: '{surface.400}',
              activeColor: '{surface.400}'
            }
          },
          fontFamily: "'Lato', sans-serif",
          contentPadding: '1.25rem',
          inlineSpacing: '0.5rem',
          borderRadius: '6px',
          focusRingShadow: '0 0 0 0.2rem #fce8ea',
          maskbg: 'rgba(0, 0, 0, 0.4)'
        }
      }
    }
  },
  components: {
    navbar: {
      colorScheme: {
        dark: {
          root: {
            background:'{surface.700}'
          }
        }
      }
    },
    button: {
      colorScheme: {
        light: {
          root: {
            color: '{primary.inverse.color}',
            background: '{primary.color}',
            border: '1px solid {primary.color}',
            padding: '0.75rem 1.25rem',
            fontSize: '1rem',
            transition:
              'background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s',
            borderRadius: '20px',
            secondary: {
              background: '#46494f',
              hoverBackground: '#46494f',
              activeBackground: '#46494f',
              borderColor: '#46494f',
              hoverBorderColor: '#46494f',
              activeBorderColor: '#46494f',
              color: '#fff',
              hoverColor: '#fff',
              activeColor: '#fff'
            }
          },
          outlined: {
            primary: {
              borderColor: '{primary.color}'
            }
          }
        },
        dark: {
          root: {
            secondary: {
              background: '#94a3b8',
              hoverBackground: '#cbd5e1',
              activeBackground: '#e2e8f0',
              borderColor: '#94a3b8',
              hoverBorderColor: '#cbd5e1',
              activeBorderColor: '#e2e8f0',
              color: '#020617',
              hoverColor: '#020617',
              activeColor: '#020617'
            }
          }
        }
      }
    },
    inputtext: {
      colorScheme: {
        light: {
          root: {
            fontSize: '1rem',
            color: '{text.color}',
            background: '{surface.0}',
            padding: '.75rem',
            border: '1px solid #ced4da',
            transition:
              'background-color .2s, color .2s, border-color .2s, box-shadow .2s',
            appearance: 'none',
            borderRadius: '6px'
          }
        },
        dark: {
          root: {
            fontSize: '1rem',
            color: '{text.color}',
            background: '{surface.900}',
            padding: '.75rem',
            border: '1px solid #ced4da',
            transition:
              'background-color .2s, color .2s, border-color .2s, box-shadow .2s',
            appearance: 'none',
            borderRadius: '6px'
          }
        }
      }
    },
    textarea: {
      colorScheme: {
        light: {
          root: {
            hoverColor: '{primary.color.text}',
            hoverBackground: '{highlight.color}',
            hoverBorderColor: '#d7dfe2',
            focusBorderColor:'#d7dfe2'
          }
        }
      }
    },
    datepicker: {
      colorScheme: {
        light: {
          root: {
            dropdown: {
              color: '{primary.color.text}',
              background: '{primary.color}',
              hoverColor: '{primary.color.text}',
              hoverBackground: '{highlight.color}',
              hoverBorderColor: '{highlight.color}'
            },
            date: {
              padding: '0'
            }
          }
        }
      }
    },
    select: {
      root: {
        hoverBorderColor: '#d7dfe2',
        focusBorderColor: '#d7dfe2'
      },
      option: {
        selectedBackground: '#fed2d733',
        selectedFocusBackground: '#fed2d733',
        selectedFocusColor: '#cd0101'
      }   
    },
    checkbox: {
      root: {
        disabledBackground: '#ffff',
        border: '2px solid #ced4da',
        width: '20px',
        height: '20px',
        borderRadius:'6px'
      }
    },
    listbox: {
      option: {
        padding: '0 0'
      }
    }
  }
});
